// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"ba59c770","136":"d4a3650f","392":"632e280e","426":"42dc06c7","438":"78532bb2","491":"8ffda4c9","512":"7aeaa767","622":"82f4b2ac","840":"4834a39e","854":"c4b29031","976":"fb9303d1"}[chunkId] + ".chunk.js";
};